import { useGetCurrentUserQuery } from '../../../store/user/userApi';
import { useGetLatestTripQuery, useGetLatestVisibleTripsQuery, useGetNotificationsMutation, useNotificationUnreadCountQuery } from '../../../store/trips/tripsApi';
import { classNames } from '../../../utils/classNames';
import NotificationsModal from '../notifications/NotificationsModal';
import { useEffect, useState } from 'react';
// import socket from '../../../utils/socket';
import { INotificationBody } from '../../../interfaces/staff/notifications/INotifications';
// import { requestNotificationPermission } from '../../../utils/requestNotificationPermission';
import { rome as moment } from '../../../utils/date';
import { NavLink } from 'react-router-dom';
import HodReportModal from '../../admin/homepage/modals/HodReportModal';
import TmReportModal from '../../admin/homepage/modals/TmReportModal';

const CheckSfaffLoggedIn = ({
	handleSetTrip
}: {
	handleSetTrip: (trip: string) => void
}) => {
	const [selectedCarriage, setSelectedCarriage] = useState<string | null>(null);
	const [groupedCabins, setGroupedCabins] = useState<Record<string, string[]>>(
		{},
	);
	const [show, setShow] = useState<boolean>(false);
	const [notificationsData, setNotificationsData] = useState<INotificationBody[]>([])
	const [hodReportModal, setHodReportModal] = useState<{ show: boolean; tripId: string; reportType: 'cabin' | 'bar' | 'restaurant' }>({ show: false, tripId: '', reportType: 'cabin' });
	const [tmReportModal, setTmReportModal] = useState<{ show: boolean; tripId: string }>({ show: false, tripId: '' });
	const { data: userInfo } = useGetCurrentUserQuery();

	const { data: latestTrip, isLoading } = useGetLatestTripQuery(userInfo?.data?._id || '', {
		skip: !userInfo?.data?._id
	});
	const { data: trip } = useGetLatestVisibleTripsQuery(userInfo?.data?._id || '', {
		skip: !userInfo?.data?._id
	});
	const { data: countUnreadNotification } = useNotificationUnreadCountQuery(
		userInfo?.data._id || '',
		{
			skip: !userInfo?.data?._id,
			refetchOnReconnect: true,
			refetchOnFocus: true,
			pollingInterval: 5000,
		}
	);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const [getNotificationsApi, { isLoading: isLoadingNotifications }] = useGetNotificationsMutation();

	const getNotifications = async (userId: string, page: number) => {
		try {
			const response = await getNotificationsApi({ recipientId: userId, page, limit: 10 }).unwrap();
			setNotificationsData([...response.notifications, ...notificationsData])
			setHasMore(response.page * response.size < response.total);
		} catch (e) {
		}
	}

	useEffect(() => {
		if (latestTrip?.[0]?._id)
			handleSetTrip(latestTrip?.[0]?._id || '')
	}, [latestTrip])

	// useEffect(()=>{
	//  getNotifications(userInfo?.data._id || '')
	// }, [userInfo?.data._id])

	useEffect(() => {
		if (!userInfo?.data?._id) return;

		getNotifications(userInfo.data._id, page);

		// const interval = setInterval(() => {
		//     getNotifications(userInfo.data._id);
		// }, 10000);

		// return () => clearInterval(interval);
	}, [userInfo?.data?._id, page]);

	const handleSetShow = () => setShow(show => !show);

	const notifications = Number(notificationsData.length);

	useEffect(() => {
		if (trip?.length) {
			const cabinIds = trip[0]?.cabinsOrdered || [];
			const grouped: Record<string, string[]> = {};

			for (const cabin of cabinIds) {
				const carriage = cabin[0];
				if (!grouped[carriage]) grouped[carriage] = [];
				grouped[carriage].push(cabin);
			}

			setGroupedCabins(grouped);
			if (!selectedCarriage && Object.keys(grouped).length > 0) {
				setSelectedCarriage(Object.keys(grouped)[0]);
			}
		}
	}, [trip]);

	const assignedCabins = latestTrip?.[0]?.assignedCabins?.[0].cabinIds || [];

	const cabinSort = (a: string, b: string) => {
		const [letterA, numA] = [a[0], parseInt(a.slice(1), 10)];
		const [letterB, numB] = [b[0], parseInt(b.slice(1), 10)];
		if (letterA === letterB) return numA - numB;
		return letterA.localeCompare(letterB);
	};

	const isBar = (id: string) => /^bar\d*$/i.test(id) || id.toLowerCase().startsWith('bar');
	const isRestaurant = (id: string) => /^restaurant\d*$/i.test(id) || id.toLowerCase().startsWith('restaurant');

	const cabinsOnly = assignedCabins.filter((id) => !isBar(id) && !isRestaurant(id)).sort(cabinSort);
	const barsOnly = assignedCabins.filter(isBar).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
	const restaurantsOnly = assignedCabins.filter(isRestaurant).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

	// Role-based visibility: maitre → restaurants only; barman → bars only; admin/train_manager → both + cabins; others → cabins only
	const roleRaw = userInfo?.data?.role;
	const isMaitre = roleRaw === 'maitre';
	const isBarman = roleRaw === 'barman' || roleRaw === 'head_barman';
	const isAdmin = ['admin', 'admins', 'super_admin'].includes(roleRaw);
	const isTrainManager = roleRaw === 'train_manager';
	const showCabins = !isMaitre && !isBarman;
	const showRestaurants = isMaitre || isAdmin || isTrainManager;
	const showBars = isBarman || isAdmin || isTrainManager;

	return (
		<>
			{notifications > 0 && <NotificationsModal
				notifications={notificationsData || []}
				open={show}
				tripId={latestTrip?.[0]?._id || ''}
				onClose={handleSetShow}
				setPage={setPage}
				isLoadingNotifications={isLoadingNotifications}
				hasMore={hasMore}
				page={page}
				onOpenHodReport={(tId, rType) => setHodReportModal({ show: true, tripId: tId, reportType: rType })}
				onOpenTmReport={(tId) => setTmReportModal({ show: true, tripId: tId })}
			/>}
			<div className='border border-gray-200 rounded-lg p-4 mb-4 w-full max-w-full xl:w-[760px] relative mx-auto'>
				{Number(latestTrip?.length || 0) > 0 ? (
					<>
						<div className='flex flex-row'>
							<div className='pr-5'>
								<h4 className='text-gray-800 dark:!text-primary-darkMode font-bold text-lg md:text-2xl'>{latestTrip?.[0]?.itinerary?.journeyTitle}</h4>
								<p className='text-gray-500 text-sm font-normal mb-2'>{latestTrip?.[0]?.itinerary?.description}</p>
								<p className='text-gray-500 text-sm font-normal'>{latestTrip?.[0]?.itinerary?.duration}</p>
								<p className='text-gray-500 text-sm font-bold '>{latestTrip?.[0]?.itinerary?.locations.join('-')}</p>
								<p className='text-gray-500 text-sm'>{moment(latestTrip?.[0]?.startDate).format('DD-MM-YYYY')} - {moment(latestTrip?.[0].endDate).format('DD-MM-YYYY')}</p>
							</div>
							<button onClick={handleSetShow} type='button'
								className={classNames(' text-white p-2 w-14 h-14 rounded-md whitespace-nowrap flex items-center justify-center ml-auto hover:bg-opacity-80 relative flex-shrink-0 my-auto',
									notifications > 0 ? 'bg-error' : 'bg-primary-default')}
							>
								{notifications ? <img src="/svg/icons/badge-white.svg" alt="badge" className='w-6 h-6' /> : <img src="/svg/icons/badge.svg" alt="badge" className='w-6 h-6' />}
								{!!notifications && <span className='absolute top-2.5 right-2.5 block border border-error px-1 rounded-full bg-error text-white text-xs'>{countUnreadNotification?.unreadCount}</span>}
							</button>
						</div>
						<div className="my-2 text-gray-900 dark:text-primary-darkMode">
							{/* Title Section */}
							<p className="font-normal">
								<i>You’re in charge of:</i>{' '}
								<span className="font-bold">
									{showCabins && cabinsOnly.length > 0 && (
										<>Carriage {Array.from(new Set(cabinsOnly.map((item) => item[0]))).join(', ')}</>
									)}
									{!showCabins && showRestaurants && showBars && <>Restaurants, Bars</>}
									{!showCabins && showRestaurants && !showBars && <>Restaurants</>}
									{!showCabins && showBars && !showRestaurants && <>Bars</>}
								</span>
							</p>

							<div className="font-bold space-y-1">
								{showCabins && cabinsOnly.length > 0 && <p>Cabins: {cabinsOnly.join(', ')}</p>}
								{showBars && barsOnly.length > 0 && <p>Bars: {barsOnly.join(', ')}</p>}
								{showRestaurants && restaurantsOnly.length > 0 && <p>Restaurants: {restaurantsOnly.join(', ')}</p>}
							</div>

							{/* Carriage Buttons + Cabin Cards – only for roles that see cabins */}
							{showCabins && (
								<>
									<div className="flex gap-3 overflow-x-auto my-4">
										{Object.keys(groupedCabins).map((carriage) => (
											<button
												key={carriage}
												onClick={() => setSelectedCarriage(carriage)}
												className={`flex items-center px-3 py-2 rounded-2xl border-2 transition-colors ${selectedCarriage === carriage
														? 'bg-gray-900 border-gray-900 text-white'
														: 'bg-gray-100 border-gray-100 text-gray-900 dark:bg-gray-700 dark:border-gray-700 dark:text-primary-darkMode'
													}`}
											>
												{selectedCarriage === carriage ? <img alt='train-white' src='/svg/icons/train-white.svg' /> : <img alt='train' src='/svg/icons/train-black.svg' />}
												<span className="ml-2 font-semibold">{carriage}</span>
											</button>
										))}
									</div>

									<div className="flex gap-3 overflow-x-auto mt-4 py-2">
										{(groupedCabins[selectedCarriage ?? ''] || []).map((item, index: number) => (
											<NavLink
												key={index}
												to={`/staff/chat/${latestTrip?.[0]?._id}?tripId=${trip?.[0]?._id}&cabinId=${item}&from=Home&message=Provide feedback for cabin ${selectedCarriage}${item[1]} by voice or text`}
												className="w-12 h-20 bg-gray-200 dark:bg-gray-700 rounded-md flex flex-col items-center justify-between py-2 cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-600"
											>
												<span className="text-3xl font-semibold text-gray-900 dark:text-primary-darkMode">{item[1]}</span>
												<span className="text-xs font-normal text-gray-700 dark:text-gray-300">Cabin</span>
											</NavLink>
										))}
									</div>
								</>
							)}

							{/* Restaurant & Bar – clickable; visibility by role */}
							{((showRestaurants && restaurantsOnly.length > 0) || (showBars && barsOnly.length > 0)) && (
								<div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 ${showCabins ? 'border-t border-gray-200 dark:border-gray-700 pt-4' : ''}`}>
									{showRestaurants && restaurantsOnly.length > 0 && (
										<div>
											<p className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Restaurant</p>
											<div className="flex flex-wrap gap-2">
												{restaurantsOnly.map((id) => (
													<NavLink
														key={id}
														to={`/staff/chat/${latestTrip?.[0]?._id}?tripId=${trip?.[0]?._id}&cabinId=${id}&from=Home&message=Provide feedback for ${id} by voice or text`}
														className="px-4 py-3 rounded-xl bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-primary-darkMode font-medium cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors min-w-[120px] text-center"
													>
														{id}
													</NavLink>
												))}
											</div>
										</div>
									)}
									{showBars && barsOnly.length > 0 && (
										<div>
											<p className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Bar</p>
											<div className="flex flex-wrap gap-2">
												{barsOnly.map((id) => (
													<NavLink
														key={id}
														to={`/staff/chat/${latestTrip?.[0]?._id}?tripId=${trip?.[0]?._id}&cabinId=${id}&from=Home&message=Provide feedback for ${id} by voice or text`}
														className="px-4 py-3 rounded-xl bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-primary-darkMode font-medium cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors min-w-[120px] text-center"
													>
														{id}
													</NavLink>
												))}
											</div>
										</div>
									)}
								</div>
							)}
						</div>
						<div className='flex flex-row justify-end my-3 gap-2 flex-wrap'>
							{trip?.[0]?.reportInfo?.reportReady && (
								<button
									onClick={() => setHodReportModal({
										show: true,
										tripId: trip?.[0]?._id || latestTrip?.[0]?._id || '',
										reportType: trip?.[0]?.reportInfo?.type || 'cabin',
									})}
									className={`btn-primary-rounded-less !text-sm !shadow-none flex items-center gap-1.5 ${trip?.[0]?.reportInfo?.submitted
											? '!bg-green-100 !text-green-800'
											: '!bg-blue-100 !text-blue-800'
										}`}
								>
									{trip?.[0]?.reportInfo?.submitted && (
										<svg className='w-3.5 h-3.5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
											<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2.5} d='M5 13l4 4L19 7' />
										</svg>
									)}
									{(trip?.[0]?.reportInfo?.type || 'cabin').replace(/^\w/, (c: string) => c.toUpperCase())} Report
								</button>
							)}
							<NavLink
								className='btn-primary-rounded-less !text-black !text-sm dark:!text-primary-darkMode dark:!bg-black !bg-gray-200 !shadow-none'
								to={`/staff/chat/${latestTrip?.[0]?._id}?type=report-reminder`}
							>
								Train Manager’s Report
							</NavLink>
						</div>
					</>
				) : (
					isLoading ? (
						<div className='flex flex-row'>
							<p className='text-gray-800 text-[13px] font-normal italic dark:text-white'>Loading...</p>
						</div>
					) : (
						<div className='flex flex-row'>
							<p className='text-gray-800 text-[13px] font-normal italic dark:text-white'>No trip assign</p>
						</div>
					)
				)}
			</div>
			<HodReportModal
				open={hodReportModal.show}
				tripId={hodReportModal.tripId}
				reportType={hodReportModal.reportType}
				onClose={() => setHodReportModal({ show: false, tripId: '', reportType: 'cabin' })}
			/>
			<TmReportModal
				open={tmReportModal.show}
				tripId={tmReportModal.tripId}
				onClose={() => setTmReportModal({ show: false, tripId: '' })}
			/>
		</>
	)
}

export default CheckSfaffLoggedIn;